//require('../kendo.core.js');

(function($, undefined$1) {

/* CUSTOM (NOT INCLUDED IN THE RELEASE FROM KENDO) */
/* ----------------------------------------------- */
/* Calendar */

if (kendo.ui.Calendar) {
kendo.ui.Calendar.prototype.options.messages =
$.extend(true, kendo.ui.Calendar.prototype.options.messages, {
    "today": "Today",
    "parentViews": {
        "decade": "decade",
        "month": "month",
        "year": "year"
    },
    "navigateTo": "Navigate To"
});
}

/* ----------------------------------------------- */

})(window.kendo.jQuery);
